import { render, staticRenderFns } from "./Attachments.vue?vue&type=template&id=5b18cda7&scoped=true&"
import script from "./Attachments.vue?vue&type=script&lang=ts&"
export * from "./Attachments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b18cda7",
  null
  
)

export default component.exports